// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_I-z","hovered":"aJ-z","hoverImage":"bJ-z","mainImage":"cJ-z","imageNoBackground":"dJ-z","fullSizeImage":"eJ-z"};